import React from 'react';

import Stack from '@mui/material/Stack';

import {
  Option,
  StepInput,
  StepSelect,
} from 'client/app/apps/disco-prototype/components/Steps';
import ModeButtonGroup from 'client/app/apps/disco-prototype/components/Steps/StepSelector/ModeButtonGroup';
import { Value } from 'client/app/apps/disco-prototype/state/table';

type Props = {
  volume: Value;
  options: Option[];
  constOptions?: Option[];
  handleUpdateValue: (key: string, value: string) => void;
};

const ValueInput = ({ volume, options, constOptions, handleUpdateValue }: Props) => {
  return (
    <Stack direction="row" spacing={2}>
      <ModeButtonGroup
        mode={volume.selectedMode || 'column'}
        onChange={newMode => handleUpdateValue('selectedMode', newMode)}
      />
      {volume.selectedMode === 'const' ? (
        constOptions ? (
          <StepSelect
            value={volume.value || ''}
            label="Value"
            options={constOptions}
            onChange={e => handleUpdateValue('value', e.target.value)}
          />
        ) : (
          <StepInput
            label="Value"
            value={volume.value || ''}
            onChange={e => handleUpdateValue('value', e.target.value)}
          />
        )
      ) : (
        <StepSelect
          value={volume.selectedColumnName || ''}
          label="Column name"
          options={options}
          onChange={e => handleUpdateValue('selectedColumnName', e.target.value)}
        />
      )}
    </Stack>
  );
};

export default ValueInput;
